import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, Form, Input, message, Popconfirm, Tag } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
// import type { ColumnsType } from 'antd/es/table';
import './index.css';

const Apps = () => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingApp, setEditingApp] = useState(null);
  const [form] = Form.useForm();

  // 表格列定义
  const columns = [
    {
      title: '应用名称',
      dataIndex: 'name',
      key: 'name',
      width: 200,
    },
    {
      title: '应用ID',
      dataIndex: 'appId',
      key: 'appId',
      width: 200,
    },
    {
      title: '回调地址',
      dataIndex: 'callbackUrl',
      key: 'callbackUrl',
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? '启用' : '禁用'}
        </Tag>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 180,
    },
    {
      title: '操作',
      key: 'action',
      width: 150,
      fixed: 'right',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            编辑
          </Button>
          <Popconfirm
            title="确定要删除这个应用吗？"
            onConfirm={() => handleDelete(record.id)}
            okText="确定"
            cancelText="取消"
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              删除
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // 获取应用列表
  const fetchApps = async () => {
    setLoading(true);
    try {
      // TODO: 调用实际API
      // const response = await getApps();
      // setApps(response.data);
      
      // 模拟数据
      setTimeout(() => {
        setApps([
          {
            id: 1,
            name: '管理系统',
            appId: 'app_001',
            callbackUrl: 'http://localhost:3001/callback',
            status: 'active',
            createTime: '2024-01-01 10:00:00',
          },
          {
            id: 2,
            name: '移动端应用',
            appId: 'app_002',
            callbackUrl: 'http://localhost:3002/callback',
            status: 'active',
            createTime: '2024-01-02 10:00:00',
          },
        ]);
        setLoading(false);
      }, 500);
    } catch (error) {
      message.error('获取应用列表失败');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApps();
  }, []);

  // 新增应用
  const handleAdd = () => {
    setEditingApp(null);
    form.resetFields();
    setModalVisible(true);
  };

  // 编辑应用
  const handleEdit = (record) => {
    setEditingApp(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  // 删除应用
  const handleDelete = async (id) => {
    try {
      // TODO: 调用实际API
      // await deleteApp(id);
      message.success('删除成功');
      fetchApps();
    } catch (error) {
      message.error('删除失败');
    }
  };

  // 保存应用
  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      
      // TODO: 调用实际API
      // if (editingApp) {
      //   await updateApp(editingApp.id, values);
      // } else {
      //   await createApp(values);
      // }
      
      message.success(editingApp ? '更新成功' : '创建成功');
      setModalVisible(false);
      form.resetFields();
      fetchApps();
    } catch (error) {
      console.error('保存失败:', error);
    }
  };

  return (
    <div className="apps-page">
      <div className="page-header">
        <h2>应用管理</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAdd}
        >
          新增应用
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={apps}
        rowKey="id"
        loading={loading}
        scroll={{ x: 1000 }}
        pagination={{
          total: apps.length,
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `共 ${total} 条`,
        }}
      />

      <Modal
        title={editingApp ? '编辑应用' : '新增应用'}
        open={modalVisible}
        onOk={handleSave}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
        }}
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{ status: 'active' }}
        >
          <Form.Item
            name="name"
            label="应用名称"
            rules={[{ required: true, message: '请输入应用名称' }]}
          >
            <Input placeholder="请输入应用名称" />
          </Form.Item>

          <Form.Item
            name="appId"
            label="应用ID"
            rules={[{ required: true, message: '请输入应用ID' }]}
          >
            <Input placeholder="请输入应用ID" disabled={!!editingApp} />
          </Form.Item>

          <Form.Item
            name="callbackUrl"
            label="回调地址"
            rules={[
              { required: true, message: '请输入回调地址' },
              { type: 'url', message: '请输入有效的URL' },
            ]}
          >
            <Input placeholder="http://example.com/callback" />
          </Form.Item>

          <Form.Item
            name="secret"
            label="应用密钥"
            rules={[{ required: true, message: '请输入应用密钥' }]}
          >
            <Input.Password placeholder="请输入应用密钥" />
          </Form.Item>

          <Form.Item
            name="description"
            label="应用描述"
          >
            <Input.TextArea rows={4} placeholder="请输入应用描述" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Apps;

